import { useRef, useState, useLayoutEffect } from "react";
import "../styles/Collapsible.css";

export default function Collapsible({ title, children, defaultOpen = false }) {
  const [open, setOpen] = useState(defaultOpen);
  const contentRef = useRef(null);
  const [height, setHeight] = useState(0);

  useLayoutEffect(() => {
    if (!contentRef.current) return;

    if (open) {
      setHeight(contentRef.current.scrollHeight);
    } else {
      setHeight(0);
    }
  }, [open, children]);

  return (
    <div className="container">
      <button
        type="button"
        className="header"
        onClick={() => setOpen(prev => !prev)}
      >
        <span>{title}</span>
        <span className={`icon ${open ? 'open' : ""}`}>
          ▾
        </span>
      </button>

      <div
        className="contentWrapper"
        style={{ maxHeight: height }}
      >
        <div ref={contentRef} className="content">
          {children}
        </div>
      </div>
    </div>
  );
}
